import { SubAPI } from "./SubAPI";
export class ProjectSov extends SubAPI {
    getAll(input) { return this.fetcher.get("/api/project-sov", input); }
    setMainContractProof(input) { const obj = { info: JSON.stringify({ project: input.project }) }; if (input.file) {
        obj.file = input.file;
    } return this.fetcher.postFormData("/api/project-sov/set-main-contract-proof", obj); }
    upsertHeading(input) { return this.fetcher.post("/api/project-sov/heading", input); }
    upsertHeadingItem(input) { return this.fetcher.post("/api/project-sov/heading/item", input); }
    lockHeadings(input) { return this.fetcher.post("/api/project-sov/lock-headings", input); }
    setPriceLink(props) { return this.fetcher.post("/api/project-sov/heading/set-price-link", props); }
    upsertChange(input) { return this.fetcher.post("/api/project-sov/change", input); }
    upsertChangeTask(input) { return this.fetcher.post("/api/project-sov/change/task", input); }
    getChange(props) { return this.fetcher.get("/api/project-sov/change", props); }
    listChanges(props) { return this.fetcher.get("/api/project-sov/changes", props); }
    uploadChangeFile(props) { return this.fetcher.postFormData("/api/project-sov/change/upload-file", { file: props.file, info: JSON.stringify({ change: props.change, changeset: props.changeset, tag: props.tag }) }); }
    listChangeFiles(props) { return this.fetcher.get("/api/project-sov/change/files", props); }
    upsertChangeFile(props) { return this.fetcher.post("/api/project-sov/change/file", props); }
} // see NoSovForChangeError in core/project/sov/main.go
export const NoSovForChangeError = "User didn't create an SOV for this change";
export function getFileTagName(tag) { switch (tag) {
    case "level-1-approval": return "Email Approval";
    case "level-2-approval": return "PO / Signed Contract";
    case "customer-summary": return "Customer Summary";
    default: return tag;
} }
